import ConfiguracaoWhiteLabelService from "@/services/ConfiguracaoWhiteLabelService";

export const configuracaoWhiteLabel = {
  namespaced: true,
  state: {
    configuracaoWhiteLabel: {},
  },
  actions: {
    getConfiguracaoWhiteLabel({ commit }, payload) {
      return ConfiguracaoWhiteLabelService.GetConfiguracaoWhiteLabel(
        payload
      ).then(
        (configuracaoWhiteLabel) => {
          return Promise.resolve(configuracaoWhiteLabel);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postConfiguracaoWhiteLabel({ commit }, payload) {
      return ConfiguracaoWhiteLabelService.PostConfiguracaoWhiteLabel(
        payload
      ).then(
        (configuracaoWhiteLabel) => {
          return Promise.resolve(configuracaoWhiteLabel);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putConfiguracaoWhiteLabel({ commit }, payload) {
      return ConfiguracaoWhiteLabelService.PutConfiguracaoWhiteLabel(
        payload
      ).then(
        (configuracaoWhiteLabel) => {
          return Promise.resolve(configuracaoWhiteLabel);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteConfiguracaoWhiteLabel({ commit }, payload) {
      return ConfiguracaoWhiteLabelService.DeleteConfiguracaoWhiteLabel(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getConfiguracaoWhiteLabelOData({ commit }, payload) {
      return ConfiguracaoWhiteLabelService.GetConfiguracaoWhiteLabelOData(
        payload
      ).then(
        (configuracaoWhiteLabel) => {
          return Promise.resolve(configuracaoWhiteLabel);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    carregarUrl({ commit }, payload) {
      return ConfiguracaoWhiteLabelService.CarregarUrl(payload).then(
        (configuracaoWhiteLabel) => {
          return Promise.resolve(configuracaoWhiteLabel);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postConfiguracaoWhiteLabelUpload({ commit }, payload) {
      return ConfiguracaoWhiteLabelService.PostConfiguracaoWhiteLabelUpload(
        payload
      ).then(
        (configuracaoWhiteLabelUpload) => {
          return Promise.resolve(configuracaoWhiteLabelUpload);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default configuracaoWhiteLabel;
